import api from '../../services/api';
import { fileNameFromDisposition, saveBlob } from '../performance-report-card/config/reportCardPdf';
import { GROUP_NODE_TYPE, MORE_NODE_TYPE, TEAM_BOX_TYPE } from './orgChartModel';

// Organizasyon şeması PDF'i sunucuda üretilir (QuestPDF — OrgChartPdfService). İstemci ekranda ÇİZİLİ yerleşimi gönderir:
// kart konumu + departman rengi, ekip kutuları, boş koltuk grupları (üye kimlikleriyle), "Daha Göster" kartları ve hazır
// çizgi yolları. Ad/ünvan/fotoğraf GÖNDERİLMEZ — sunucu kimliklerden, ekrandaki görünürlük kuralıyla okur.

export const ORG_CHART_PDF_URL = '/v1/org-chart/export/pdf';

// Sunucu yer tutucuları {name}/{count}/... kendisi doldurur (OrgChartPdfModelBuilder.DefaultLabels ile aynı anahtarlar).
export function buildOrgChartPdfLabels(t) {
  return {
    docTitle: t('orgChart.pdf.docTitle'),
    scopeVisible: t('orgChart.pdf.scopeVisible'),
    scopeBranch: t('orgChart.pdf.scopeBranch', { name: '{name}' }),
    generatedAt: t('orgChart.pdf.generatedAt', { date: '{date}' }),
    summary: t('orgChart.pdf.summary', { people: '{people}', positions: '{positions}' }),
    legendMore: t('orgChart.legendMore', { count: '{count}' }),
    morePositions: t('orgChart.pdf.morePositions', { count: '{count}' }),
    vacantPosition: t('orgChart.vacantPosition'),
    vacantGroupCard: t('orgChart.vacantGroupCard', { count: '{count}' }),
    teamBoxTitle: t('orgChart.teamBoxTitle', { name: '{name}', count: '{count}' }),
    teamBoxTitleNoName: t('orgChart.teamBoxTitleNoName', { count: '{count}' }),
  };
}

// `include` ("Seçili Dal", branchOf çıktısı): yalnız bu düğüm ve kenar kimlikleri yüke girer.
export function buildOrgChartPdfPayload({
  nodes, edges, include = null, labels, lang, edit = false, branchRootId = null,
}) {
  const keep = (n) => !include || include.nodeIds.has(n.id);
  const at = (n) => ({ x: n.position?.x ?? 0, y: n.position?.y ?? 0 });
  const cards = [];
  const groups = [];
  const more = [];
  const boxes = [];
  (nodes || []).filter(keep).forEach((n) => {
    const d = n.data || {};
    if (n.type === TEAM_BOX_TYPE) {
      boxes.push({ ...at(n), width: d.width, height: d.height, parentId: d.parentId || null, count: d.count || 0 });
    } else if (n.type === GROUP_NODE_TYPE) {
      groups.push({ ...at(n), memberIds: d.memberIds || [] });
    } else if (n.type === MORE_NODE_TYPE) {
      more.push({ ...at(n), remaining: d.remaining || 0 });
    } else {
      cards.push({
        positionId: String(d.positionId ?? n.id), ...at(n), color: d.color || null, expanded: Boolean(d.isExpanded),
      });
    }
  });
  const lines = (edges || [])
    .filter((e) => e.data?.path && (!include || include.edgeIds.has(e.id)))
    .map((e) => ({ path: e.data.path }));
  return {
    lang: lang || undefined, labels, edit: Boolean(edit), branchRootId: branchRootId || null, cards, groups, more, boxes, edges: lines,
  };
}

/** Başarıda true; hata → false (toast Axios interceptor'ında, bileşende YOK). */
export async function downloadOrgChartPdf(payload, fallbackName) {
  try {
    const res = await api.post(ORG_CHART_PDF_URL, payload, { responseType: 'blob' });
    const type = res?.headers?.['content-type'] || '';
    if (!res?.data || !/pdf/i.test(type)) return false;
    const blob = new Blob([res.data], { type });
    saveBlob(blob, fileNameFromDisposition(res.headers['content-disposition'], fallbackName));
    return true;
  } catch {
    return false;
  }
}
